const usCreditReportResponse = require('../../mock/usCreditReport.json');
const creditQuestionsResponse = require('../../mock/creditQuestions.json');
const creditPlusResponse = require('../../mock/creditPlus.json');
const inventoryMatchedResults = require('../../mock/inventoryMatchedResults.json');

export default {
  getQuestions: payload =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({ data: creditQuestionsResponse[payload.language] });
      }, 1000);
    }),
  answerQuestions: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({ data: creditPlusResponse });
      }, 1000);
    }),
  prequalify700: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({ data: usCreditReportResponse });
      }, 1000);
    }),
  prequalify700Equifax: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({ data: usCreditReportResponse });
      }, 1000);
    }),
  prequalify700EquifaxAnswered: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({ data: usCreditReportResponse });
      }, 1000);
    }),
  prequalify700WithPin: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({ data: usCreditReportResponse });
      }, 1000);
    }),
  getConsumerInventoryMatch: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({ data: inventoryMatchedResults });
      }, 500);
    }),
};
